export const PAY_RATE_INFO_TEXT =
  'This is what you pay the consultant at payroll time.';

export function resolvePayRateFromInput(raw, salesPrice) {
  const text = String(raw ?? '').trim();
  if (!text) {
    return { value: '', error: null };
  }

  const isPercent = text.includes('%');
  const numeric = text.replace(/[^\d.]/g, '');
  const parts = numeric.split('.');
  let cleaned = parts.length > 2 ? `${parts[0]}.${parts.slice(1).join('')}` : numeric;
  if (cleaned.startsWith('.')) {
    cleaned = `0${cleaned}`;
  }

  const amount = Number(cleaned);
  if (!cleaned || Number.isNaN(amount)) {
    return { value: text, error: 'Pay Rate must be a number or a percent (for example 80%).' };
  }
  if (amount < 0) {
    return { value: text, error: 'Pay Rate cannot be negative.' };
  }

  if (isPercent) {
    const sales = Number(salesPrice);
    if (salesPrice === '' || salesPrice == null || Number.isNaN(sales)) {
      return { value: text, error: 'Enter Sales Price first to use a percent pay rate.' };
    }
    return { value: ((sales * amount) / 100).toFixed(2), error: null };
  }

  return { value: amount.toFixed(2), error: null };
}

export function numericPayRateForSave(raw, salesPrice) {
  const resolved = resolvePayRateFromInput(raw, salesPrice);
  if (resolved.error || resolved.value === '') {
    return null;
  }
  return Number(resolved.value);
}

export function isAllowedPayRateTyping(raw) {
  return !raw || /^[\d.%]*$/.test(String(raw));
}

export function salesPriceFromPrimaryService(services) {
  const list = Array.isArray(services) ? services : [];
  const isPrimary = (service) =>
    service.is_primary_agreement === true ||
    service.is_primary_agreement === 'true' ||
    service.is_primary_agreement === 1;
  const primary = list.find(isPrimary);
  if (primary && primary.salesPrice !== '' && primary.salesPrice != null) {
    return primary.salesPrice;
  }
  const firstPriced = list.find((service) => service.salesPrice !== '' && service.salesPrice != null);
  return firstPriced ? firstPriced.salesPrice : '';
}
